import React from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';

import { DotList } from '@motorway/mw-highway-code';

import { sanitiseLinks, wordpressImgToImgixURL } from 'Utilities';

import styles from './BlogPost.scss';

type BlogPostProps = {
  author: {
    name: string;
  };
  className?: string;
  content: string;
  date: string;
  noLink: boolean;
  slug?: string | null;
  title: string;
  wordpressContent: {
    className?: string;
  };
};

export const BlogPost = ({
  author,
  className,
  content,
  date,
  noLink,
  slug = null,
  title,
  wordpressContent,
}: BlogPostProps) => {
  const history = useHistory();

  const linkClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;
    const url = target.getAttribute('href');

    // Don't break middle-click or (meta|ctrl)+click (new tab)
    if (
      target instanceof HTMLAnchorElement && url?.charAt(0) === '/' && !(e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey)
    ) {
      e.preventDefault();
      history.push(url);
    }
  };

  return (
    <div className={cx(styles.component, className)} onClick={linkClick}>
      <div className={styles.header}>
        {noLink ? (
          <h1
            dangerouslySetInnerHTML={{ __html: title }}
            className={styles.postTitle}
          />
        ) : (
          <h2>
            <a dangerouslySetInnerHTML={{ __html: title }} href={slug || undefined} />
          </h2>
        )}
        <DotList
          data-thc-dotlist
          narrow
          data={[
            { content: author.name, key: 'a' },
            { content: date, key: 'b' },
          ]}
        />
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: sanitiseLinks(wordpressImgToImgixURL(content)),
        }}
        {...wordpressContent}
      />
    </div>
  );
};
